import React from 'react';
import PropTypes from 'prop-types';
import { Label as CargomaticLabel } from '@cargomatic/ui';
import CargomaticTooltip from '../Tooltip';
import { getClassName } from '../../../utils/ui/classes';
const baseClasses = ['block', 'form-label'];
const Label = ({ children, helptext, htmlFor, className, style, position, labelClassName, dataTestId, }) => {
    const getContainerClass = () => {
        if (helptext) {
            return getClassName('flex', className);
        }
        return getClassName('flex', 'items-center', className);
    };
    return (React.createElement("div", { "data-testid": dataTestId, className: getContainerClass() },
        React.createElement(CargomaticLabel, { "data-testid": "label-8eabaaa8", htmlFor: htmlFor, className: getClassName(baseClasses, labelClassName), style: style }, children),
        helptext && (React.createElement(CargomaticTooltip, { dataTestId: "CargomaticTooltip-1822dd4f", id: helptext, className: "ml-1", position: position }, helptext))));
};
Label.propTypes = {
    htmlFor: PropTypes.string,
    helptext: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    position: PropTypes.string,
    style: PropTypes.object,
};
Label.defaultProps = {
    position: 'top',
};
export default Label;
